import React from "react";
import { Alert, Text, Title } from "@gjensidige/builders-components";

const ApiErrorMessage = () => (
  <Alert severity="error" style={{ whiteSpace: "pre-line" }} tracking={{eventLabel: 'der-skete-en-fejl'}}>
    <Title>Der skete en fejl.</Title>
    <Text>Der skete en fejl ved indsendelse. Prøv venligst igen senere</Text>
  </Alert>
);

export default ApiErrorMessage;
